<template>
    <div>
        <div class="title">{{$route.name}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
};
</script>

<style  scoped>
.title{
    width: 100%;
    background: tomato;
    line-height: 40px;
    height: 40px;
    color: #333;
    text-align: center;
}
</style>
